export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};
export const lightTheme = (theme) => theme.palette.mode === "light";
export const secondarySideBarWidth = 215;
export const secondarySideBarGap = 80;
export const DRF_DATE_FORMAT = "YYYY-MM-DD";
export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DEFAULT_PAGE_TITLE = "Plataforma Indie Energy";